import {FETCH_DSA_OEM_ADMIN_URL_REQUEST, FETCH_DSA_OEM_ADMIN_URL_SUCCESS, FETCH_DSA_OEM_ADMIN_URL_FAILURE, DELETE_DSA_OEM_ADMIN_URL_REQUEST, DELETE_DSA_OEM_ADMIN_URL_SUCCESS, DELETE_DSA_OEM_ADMIN_URL_FAILURE, CHECK_TAG_COUNTRIES, UPDATE_TARGETING_TAGS} from './DSAOemAdminUrlTypes';
import ApiManager from '../../ApiManager/ApiManager';

export const fetchDsaOemAdminUrlRequest = () => {
  return {
    type: FETCH_DSA_OEM_ADMIN_URL_REQUEST,
  };
};

export const fetchDsaOemAdminUrlSuccess = (data) => {
  return {
    type: FETCH_DSA_OEM_ADMIN_URL_SUCCESS,
    payload: data,
  };
};
export const fetchDsaOemAdminUrlFailure = (error) => {
  return {
    type: FETCH_DSA_OEM_ADMIN_URL_FAILURE,
    payload: error,
  };
};

export const fetchDeleteDsaOemAdminUrlRequest = () => {
  return {
    type: DELETE_DSA_OEM_ADMIN_URL_REQUEST,
  };
};

export const fetchDeleteDsaOemAdminUrlSuccess = (data) => {
  return {
    type: DELETE_DSA_OEM_ADMIN_URL_SUCCESS,
    payload: data,
  };
};  

export const fetchDeleteDsaOemAdminUrlFailure = (error) => {
  return {
    type: DELETE_DSA_OEM_ADMIN_URL_FAILURE,
    payload: error, 
  }
};

export const fetchDsaOemAdminUrl = () => {
  return async (dispatch) => {
    dispatch(fetchDsaOemAdminUrlRequest());
    try {
      const response = await ApiManager.getDSAUrl(sessionStorage.getItem("portfolioId"));
      dispatch(fetchDsaOemAdminUrlSuccess(response));
    } catch (error) {
      dispatch(fetchDsaOemAdminUrlFailure(error.message));
    }
  };
};

export const deleteDsaOemAdminUrl = (propertyKey) => {
  return async (dispatch) => {
    dispatch(fetchDeleteDsaOemAdminUrlRequest());
    try {
      await ApiManager.deleteDSAUrl(sessionStorage.getItem("portfolioId"), propertyKey);
      dispatch(fetchDeleteDsaOemAdminUrlSuccess(propertyKey));
      await dispatch(fetchDsaOemAdminUrl())
    } catch (error) {
      dispatch(fetchDeleteDsaOemAdminUrlFailure(error.message));
    }
  };
};

export const patchDSAOemAdminUrl = (payload) => {
  return async (dispatch) => {
    dispatch(fetchDsaOemAdminUrlRequest());
    try {
       await ApiManager.patchDSAUrl(sessionStorage.getItem("portfolioId"), payload);
       await dispatch(fetchDsaOemAdminUrl())
    } catch (error) {
      dispatch(fetchDsaOemAdminUrlFailure(error.message));
    }
  };
};

export const checkEuropeanCountries = (isEuropeanCountry) => {
  return {
    type: 'CHECK_EUROPEAN_COUNTRIES',
    payload: isEuropeanCountry,
  };
}

export const checkTagCountries =(newSelectedCountries)=>{
  return {
    type: CHECK_TAG_COUNTRIES,
    payload:newSelectedCountries,
  }
}

export const updateTargetingTags = (updatedTags) => {
  return {
    type: UPDATE_TARGETING_TAGS,
    payload: updatedTags,
  };
}
